import { useForm, wrapInput, wrapSubmit, Form } from '@danderson00/react-forms'
import {
  Button,
  Input,
  Avatar as AvatarWidget,
  CitySearch as CitySearchWidget,
  CountryDropDown as CountryDropDownWidget,
  Coupon as CouponWidget,
  CreditCard as CreditCardWidget,
  Digits as DigitsWidget,
  SelectableList as SelectableListWidget
} from '../widgets'

export { useForm, wrapInput, Form }
export * from './Boolean.jsx'
export * from './Checkbox.jsx'
export * from './DropDown.jsx'
export * from './Radio.jsx'
export * from './Password.jsx'
export const Submit = wrapSubmit(Button)
export const Text = wrapInput(Input)
export const Avatar = wrapInput(props => <AvatarWidget {...props} edit index={props.value} onAvatarSelected={props.onChange} />, { valueFromEvent: x => x })
export const Digits = wrapInput(DigitsWidget, { valueFromEvent: x => x })
export const CitySearch = wrapInput(CitySearchWidget, { valueFromEvent: x => x })
export const CountryDropDown = wrapInput(CountryDropDownWidget, { valueFromEvent: x => x })
export const Coupon = wrapInput(CouponWidget, { valueFromEvent: x => x })
export const CreditCard = wrapInput(CreditCardWidget, { valueFromEvent: x => x })
export const SelectableList = wrapInput(SelectableListWidget, { valueFromEvent: x => x })

export * from './Location.jsx'
